// test1369
(1369 && 0);
